export default "__VITE_ASSET__C0uTGCJ5__"